import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { EnvConfigurationService } from './config/env-configuration.service';
import {TestArea} from '../common/test-area';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(
    private http: HttpClient
  ) {
  }

  upload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file);


    const req = new HttpRequest('POST', `${EnvConfigurationService.configuration.API_BASE_URL}/api/v2/admin/files`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  uploadGlobal(file: File, testArea?: TestArea): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file);


    const req = new HttpRequest('POST', `${EnvConfigurationService.getDynamicTestUrl(testArea)}/api/v2/admin/global-files`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  getAllFiles(): Observable<any> {
    return this.http.get(`${EnvConfigurationService.configuration.API_BASE_URL}/api/v2/admin/files`);
  }

  getFiles(id: string): Observable<any> {
    return this.http.get(`${EnvConfigurationService.configuration.API_BASE_URL}/api/v2/admin/files?disId=${id}`);
  }

  getStatus(id: string): Observable<any> {
    return this.http.get(`${EnvConfigurationService.configuration.API_BASE_URL}/api/v2/test/dis/${id}/status`);
  }

}
